import { Icon, Illustration, Shadow, Text, HStack, VStack } from '@genial/components';
import { BoxBorder, BoxRadius, Color, Spacing, Typography } from '@genial/design-tokens';
import { useBreakpointValue } from '@genial/utils';
import { Pressable } from 'native-base';
import React, { useState } from 'react';

interface DownloadProps {}

export const Download: React.FC<DownloadProps> = () => {
  const [isOpened, setIsOpened] = useState(false);
  const isMobile = useBreakpointValue({ base: true, sm: false });

  const Wrapper = useBreakpointValue({
    base: React.Fragment,

    sm: ({ children }) => (
      <Shadow level={3} mb={Spacing['inline.xxs']} borderRadius={BoxBorder.heavy}>
        {children}
      </Shadow>
    ),
  });

  const referenceYear = new Date().getFullYear() - 1;

  const ReportIncomeExpandedComponent = (
    <VStack
      space={Spacing['inline.xxxs']}
      bg={{ base: 'neutral.white', sm: 'background' }}
      w="full"
      borderRadius={BoxRadius.sm}
      px={Spacing['inline.xxxs']}
      py={{ base: Spacing['stack.xxxs'], sm: Spacing['stack.nano'] }}>
      <VStack space={Spacing['inset.nano']}>
        <HStack alignItems="center" justifyContent="space-between">
          <Text fontSize={Typography['fontsize.md']} color="neutral.black" variant="semibold">
            Outros Informes | Ano referência {referenceYear}
          </Text>
          {isMobile && (
            <Icon
              name={isOpened ? 'ChevronUp' : 'ChevronDown'}
              size="xxs"
              color={Color['neutral.black']}
              testID="icon-arrow"
            />
          )}
        </HStack>
        <Text fontSize={Typography['fontsize.md']} color="neutral.black">
          Para clientes que possuam:
        </Text>
      </VStack>
      <VStack space={Spacing['inset.nano']}>
        <Text fontSize={Typography['fontsize.md']} color="neutral.black" variant="semibold">
          Informe Fundo Administrado com Escrituração Externa
        </Text>
        <Text fontSize={Typography['fontsize.md']} color="neutral.black">
          Referente a fundos administrados pela Genial, que possuam a sua escrituração feita por
          parceiro.
        </Text>
      </VStack>
      <VStack space={Spacing['inset.nano']}>
        <Text fontSize={Typography['fontsize.md']} color="neutral.black" variant="semibold">
          Informe de Rendimentos de Previdência
        </Text>
        <Text fontSize={Typography['fontsize.md']} color="neutral.black">
          Referente a ativos de Previdência Privada.
        </Text>
      </VStack>
    </VStack>
  );

  const ReportIncomeComponent = useBreakpointValue({
    base: (
      <Shadow level={3} w="full" bg={'amber.600'} borderRadius={BoxRadius.sm}>
        <Pressable
          display={isOpened ? 'none' : 'flex'}
          onPress={() => setIsOpened((state) => !state)}
          borderRadius={BoxRadius.sm}>
          <HStack alignItems="center" justifyContent="space-between" p={Spacing['inline.xxxs']}>
            <Text fontSize={Typography['fontsize.md']} color="neutral.black" variant="semibold">
              Outros Informes | Ano referência {referenceYear}
            </Text>
            <Icon
              name={isOpened ? 'ChevronUp' : 'ChevronDown'}
              size="xxs"
              color={Color['neutral.black']}
              testID="icon-arrow"
            />
          </HStack>
        </Pressable>
        {isOpened && (
          <Pressable onPress={() => setIsOpened((state) => !state)} borderRadius={BoxRadius.sm}>
            {ReportIncomeExpandedComponent}
          </Pressable>
        )}
      </Shadow>
    ),
    sm: ReportIncomeExpandedComponent,
  });

  return (
    <Wrapper>
      <VStack
        px={Spacing['inline.xxxs']}
        py={Spacing['inline.xxs']}
        alignItems="center"
        space={Spacing['inline.xxs']}
        justifyContent="space-between"
        borderRadius={BoxBorder.heavy}>
        {ReportIncomeComponent}
      </VStack>
      <VStack w="full">
        <VStack
          space={Spacing['inline.xxxs']}
          alignItems="center"
          justifyContent="center"
          h="full"
          pb={Spacing['inline.xxxs']}>
          <Illustration name="DownloadIllustration" />
          <VStack space={Spacing['inline.nano']} mx={Spacing['inline.md']}>
            <Text variant="bold" fontSize={Typography['fontsize.md']} textAlign="center">
              Faça o download dos informes de rendimento do cliente.
            </Text>
            <Text fontSize={Typography['fontsize.md']} textAlign="center">
              Para realizar o download selecione período em seguida clique em download.
            </Text>
          </VStack>
        </VStack>
      </VStack>
    </Wrapper>
  );
};
